import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "frame-fill-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3 9.67a.75.75 0 01-.75-.75V4c0-.97.78-1.75 1.75-1.75h4.98a.75.75 0 010 1.5H4a.25.25 0 00-.25.25v4.92c0 .42-.34.75-.75.75zM15.08 2.25a.75.75 0 000 1.5H20c.14 0 .25.11.25.25v4.98a.75.75 0 001.5 0V4c0-.97-.78-1.75-1.75-1.75h-4.92zM8.92 21.75a.75.75 0 000-1.5H4a.25.25 0 01-.25-.25v-4.98a.75.75 0 00-1.5 0V20c0 .97.78 1.75 1.75 1.75h4.92zM21.74 15.08a.75.75 0 00-1.5 0V20c0 .14-.1.25-.25.25h-4.98a.75.75 0 100 1.5H20c.97 0 1.75-.78 1.75-1.75v-4.92z" }, null, -1)
  ])))
}
export default { render: render }